<template>
  <div id="app"    >
    <router-view/>
  </div>
</template>

<script>
import { Gtoken } from '@/config/index.js'
export default {
  name: 'app',
  watch: {
    'Gtoken.aaa': 'refresh'
  },
  methods: {
    refresh() {
      console.log('重新登录了APP')
      // this.$router.push({
      //   path: '/index'
      // })

    }
  }
}

</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
@import '~@/assets/font/font.css';
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
